var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module"},[_c('div',{staticClass:"module-container",class:_vm.quote!='env'?'source':''},[_c('rcTable',{ref:"tableInstanceType",attrs:{"tableAttr":_vm.tableAttr}},[_c('Button',{attrs:{"slot":"tootipL"},on:{"click":_vm.refresh},slot:"tootipL"},[_c('i',{staticClass:"icon-refresh-o-2"})])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }